import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "notice-page"
};
var _hoisted_2 = {
  class: "notice-detail"
};
var _hoisted_3 = {
  class: "search-box"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = {
  key: 0,
  class: "empty"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 1,
  class: "content-list"
};
var _hoisted_8 = {
  key: 0,
  class: "expanded-detail"
};
var _hoisted_9 = {
  class: "message-cell"
};
var _hoisted_10 = {
  class: "operation-cell"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  key: 1,
  class: "detail-btn",
  style: {
    "visibility": "hidden"
  }
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  class: "foot"
};
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { ref, computed } from 'vue';
import { Icon } from 'tdesign-icons-vue-next';
import { getMstListAll, getBatchUpdate, getNotifyDel, batchDeleteMsg } from '@/api/home.js';
import { useRouter } from 'vue-router';
import { getEnvName, getHostName } from '@/util/env';
import { validateNull } from '@/util/validate';
import NoitceDetaill from './NoitceDetaill.vue';
import { getStore } from '@/util/store';
import NavLeftNotice from '../components/navLeftNotice.vue';
import Layout from './sourcePreview/paperDetail/practicePaper/widgets/layout.vue';
import NavBar from './sourcePreview/paperDetail/practicePaper/widgets/navBar.vue';
export default {
  __name: 'Notice',
  setup: function setup(__props) {
    var emptyImg = require('@/assets/course/teach-empty.svg');
    var pageSizeOptions = ref(['20', '50', '100', '200', '500']);
    var pageSizeRef = ref(20);
    var loading = ref(false);
    var msgList = ref([]);
    var total = ref(0);
    var current = ref(1);
    var searchKeyword = ref('');
    var tableMaxHeight = computed(function () {
      return 'calc(100vh - 266px)';
    });
    var token = getStore({
      name: 'access_token'
    });
    var columns = ref([{
      colKey: 'row-select',
      type: 'multiple',
      width: 50
    }, {
      colKey: 'message',
      title: '消息',
      ellipsis: true
    }, {
      colKey: 'createTime',
      title: '发起时间',
      width: 180
    }, {
      colKey: 'operation',
      title: '操作',
      width: 150
    }]);
    var selectedRowKeys = ref([]);
    var expandedRowKeys = ref([]);
    var onSelectChange = function onSelectChange(value) {
      selectedRowKeys.value = value;
    };
    var onExpandChange = function onExpandChange(value) {
      expandedRowKeys.value = value;
    };
    var handleSearch = function handleSearch() {
      current.value = 1;
      _getMstData({
        current: 1,
        pageSize: pageSizeRef.value
      }, searchKeyword.value);
    };
    var handleDelete = function handleDelete(row) {
      batchDeleteMsg([row.id]).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('删除成功');
          _getMstData({
            current: current.value,
            pageSize: pageSizeRef.value
          }, searchKeyword.value);
        }
      }).catch(function () {
        MessagePlugin.error('删除失败');
      });
    };
    var handleBatchDelete = function handleBatchDelete() {
      if (selectedRowKeys.value.length === 0) {
        MessagePlugin.warning('请先选择要删除的消息');
        return;
      }
      var confirmDialog = DialogPlugin.confirm({
        header: '确认删除',
        body: "\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684 ".concat(selectedRowKeys.value.length, " \u6761\u6D88\u606F\u5417\uFF1F"),
        onConfirm: function onConfirm() {
          batchDeleteMsg(selectedRowKeys.value).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('批量删除成功');
              _getMstData({
                current: current.value,
                pageSize: pageSizeRef.value
              }, searchKeyword.value);
              selectedRowKeys.value = [];
            }
          }).catch(function () {
            MessagePlugin.error('批量删除失败');
          });
          confirmDialog.destroy();
        },
        onClose: function onClose() {
          confirmDialog.destroy();
        }
      });
    };
    var _getMstData = function getMstData(pageInfo) {
      selectedRowKeys.value = [];
      var title = searchKeyword.value;
      getMstListAll({
        current: pageInfo.current,
        size: pageInfo.pageSize,
        title: title
      }).then(function (res) {
        if (res.data.code === 0) {
          var tempList = res.data.data.records;
          // 当前页无数据且不是第一页，回退到前一页
          if (tempList.length === 0 && pageInfo.current > 1) {
            var prevPage = pageInfo.current - 1;
            current.value = prevPage;
            _getMstData({
              current: prevPage,
              pageSize: pageInfo.pageSize
            }, title);
            return;
          }
          total.value = res.data.data.total;
          msgList.value = tempList.map(function (item) {
            var _item$payload, _item$payload2;
            var isUpdata = !validateNull(item === null || item === void 0 || (_item$payload = item.payload) === null || _item$payload === void 0 ? void 0 : _item$payload.id) && (item === null || item === void 0 || (_item$payload2 = item.payload) === null || _item$payload2 === void 0 ? void 0 : _item$payload2.type) === 'updateNotify';
            return _objectSpread(_objectSpread({}, item), {}, {
              isUpdata: isUpdata,
              showDetail: false,
              noitceDetaill: null
            });
          });
        }
      });
    };
    _getMstData({
      current: current.value,
      pageSize: pageSizeRef.value
    });
    getBatchUpdate();
    var router = useRouter();
    var noticeClick = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var index, _item$payload3, _item$msgSubCode, _item$msgSubCode2, _item$msgSubCode3, _item$msgSubCode4, env_name, hostName, url, _item$payload4, common, type, _common, _item$payload5, _item$payload6;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!item.isUpdata) {
                _context.n = 2;
                break;
              }
              if (!validateNull(item.noitceDetaill)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return getNotifyData(item);
            case 1:
              // 切换展开行
              index = expandedRowKeys.value.indexOf(item.id);
              if (index > -1) {
                expandedRowKeys.value.splice(index, 1);
              } else {
                expandedRowKeys.value.push(item.id);
              }
              _context.n = 3;
              break;
            case 2:
              if (item.msgContentType === 1) {
                // 跳转对应应该带路由
                env_name = getEnvName();
                hostName = getHostName();
                url = '';
                if (item.msgMainCode === 'app_auth_apply') {
                  // 应用权限申请与审批
                  if (item.msgSubCode.includes('applicant')) {
                    // 申请人
                    url = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName, "/applyApp?applyApp=%2Fapps");
                  } else {
                    // 审批人
                    url = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName, "/applyApp?applyApp=%2FpermissionApproval");
                  }
                } else if (((_item$payload3 = item.payload) === null || _item$payload3 === void 0 ? void 0 : _item$payload3.type) === 'waiting_examine') {
                  //审核工作台 0-资源库  1-校本库 2-集团库
                  common = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName);
                  type = Number((_item$payload4 = item.payload) === null || _item$payload4 === void 0 ? void 0 : _item$payload4.resWarehouseType);
                  if (type === 0) url = "".concat(common, "/sourceManage?sourceManage=%2FreviewStaging");
                  if (type === 1) url = "".concat(common, "/orgSourceManage?orgSourceManage=%2ForgReviewStaging?type=").concat(type);
                  if (type === 2) url = "".concat(common, "/orgSourceManage?orgSourceManage=%2ForgReviewStaging?type=").concat(type);
                } else if ((_item$msgSubCode = item.msgSubCode) !== null && _item$msgSubCode !== void 0 && _item$msgSubCode.includes('timetable_')) {
                  //审核工作台 0-资源库  1-校本库 2-集团库
                  _common = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName);
                  url = "".concat(_common, "/stuTimetable");
                } else if ((_item$msgSubCode2 = item.msgSubCode) !== null && _item$msgSubCode2 !== void 0 && _item$msgSubCode2.includes('sojump')) {
                  url = (_item$payload5 = item.payload) === null || _item$payload5 === void 0 ? void 0 : _item$payload5.url;
                } else if (item.msgMainCode === 'data_update' && ['growth_profile', 'stu_composite_profile', 'class_profile'].includes(item.msgSubCode)) {
                  // 数据更新通知（我的成长画像/学生综合画像/班级画像）直接跳转 payload 中的 url
                  url = (_item$payload6 = item.payload) === null || _item$payload6 === void 0 ? void 0 : _item$payload6.url;
                } else if ((_item$msgSubCode3 = item.msgSubCode) !== null && _item$msgSubCode3 !== void 0 && _item$msgSubCode3.includes('questionnaire_operation_behavior')) {
                  // 查看问卷详情
                  url = "https://".concat(env_name, "questionnaire-response.zhixuehuijiao.cn/answer?id=").concat(item.payload.questionnaireId, "&preview=0&token=").concat(token, "&systemNotice=''");
                } else if (['teacher_review', 'teacher_pub'].includes(item.msgSubCode)) {
                  // 语文作文批阅
                  url = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName, "/essayAi?essayAi=%2Fsub-essay-ai-svc%2Fpractice");
                } else if ((_item$msgSubCode4 = item.msgSubCode) !== null && _item$msgSubCode4 !== void 0 && _item$msgSubCode4.includes('class_dictation_of_word_operation_behavior')) {
                  // 学生英语学习
                  url = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName, "/englishStudy?englishStudy=%2Fsub-english-study-svc%2FwordsBook%3Ftab%3D1");
                } else {
                  url = "https://".concat(env_name ? env_name + 'web' : 'web', ".").concat(hostName, "/evaluate?evaluate=%2Fresult%2Foverview%2F").concat(item.payload.projectId);
                }
                window.location.replace(url);
              } else if (item.msgContentType === 2) {
                // 查看大图
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function noticeClick(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 获取通知详情
     */
    var getNotifyData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var res, _res$data, code, data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getNotifyDel(item.businessId);
            case 1:
              res = _context2.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                item.noitceDetaill = (data === null || data === void 0 ? void 0 : data.content) || '';
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t.message);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function getNotifyData(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var goBack = function goBack() {
      //判断当前是否存在JSAndroid方法，如果出现错误， 属于pc端
      if (window.JSAndroid) {
        window.JSAndroid.activityFinish();
      } else {
        router.back();
      }
    };
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_pagination = _resolveComponent("t-pagination");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavLeftNotice), _createVNode(Layout, null, {
        header: _withCtx(function () {
          return [_createVNode(NavBar, {
            "left-text": "消息通知",
            leftIconShow: false
          })];
        }),
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_t_input, {
            modelValue: searchKeyword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return searchKeyword.value = $event;
            }),
            placeholder: "请输入内容",
            class: "search-input",
            onEnter: handleSearch
          }, {
            "suffix-icon": _withCtx(function () {
              return [_createVNode(_component_t_icon, {
                name: "search",
                class: "search-icon",
                onClick: handleSearch
              })];
            }),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_t_button, {
            theme: "default",
            variant: "outline",
            disabled: selectedRowKeys.value.length === 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 批量删除 ", -1)]));
            }),
            _: 1
          }, 8, ["disabled"])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [msgList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
            src: _unref(emptyImg)
          }, null, 8, _hoisted_6), _cache[4] || (_cache[4] = _createElementVNode("span", null, "暂无消息通知", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_t_table, {
            class: "notice-table",
            columns: columns.value,
            data: msgList.value,
            "row-key": "id",
            "selected-row-keys": selectedRowKeys.value,
            "max-height": tableMaxHeight.value,
            "expanded-row-keys": expandedRowKeys.value,
            onSelectChange: onSelectChange,
            onExpandChange: onExpandChange
          }, {
            expandedRow: _withCtx(function (_ref3) {
              var row = _ref3.row;
              return [row.isUpdata ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(NoitceDetaill, {
                content: row.noitceDetaill
              }, null, 8, ["content"])])) : _createCommentVNode("", true)];
            }),
            message: _withCtx(function (_ref4) {
              var _row$payload, _row$payload2;
              var row = _ref4.row;
              return [_createElementVNode("div", _hoisted_9, _toDisplayString(((_row$payload = row.payload) === null || _row$payload === void 0 ? void 0 : _row$payload.content) || ((_row$payload2 = row.payload) === null || _row$payload2 === void 0 ? void 0 : _row$payload2.title)), 1)];
            }),
            createTime: _withCtx(function (_ref5) {
              var row = _ref5.row;
              return [_createElementVNode("span", null, _toDisplayString(row.createTime), 1)];
            }),
            operation: _withCtx(function (_ref6) {
              var row = _ref6.row;
              return [_createElementVNode("div", _hoisted_10, [row.msgContentType !== 0 || row.isUpdata ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "detail-btn",
                onClick: function onClick($event) {
                  return noticeClick(row);
                }
              }, "详情", 8, _hoisted_11)) : (_openBlock(), _createElementBlock("span", _hoisted_12, "详情")), _createElementVNode("span", {
                class: "detail-btn",
                onClick: function onClick($event) {
                  return handleDelete(row);
                }
              }, "删除", 8, _hoisted_13)])];
            }),
            _: 1
          }, 8, ["columns", "data", "selected-row-keys", "max-height", "expanded-row-keys"])]))])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_t_pagination, {
            current: current.value,
            "onUpdate:current": _cache[1] || (_cache[1] = function ($event) {
              return current.value = $event;
            }),
            pageSize: pageSizeRef.value,
            "onUpdate:pageSize": _cache[2] || (_cache[2] = function ($event) {
              return pageSizeRef.value = $event;
            }),
            "show-jumper": "",
            "show-size-changer": "",
            total: total.value,
            pageSizeOptions: pageSizeOptions.value,
            onChange: _getMstData
          }, null, 8, ["current", "pageSize", "total", "pageSizeOptions"])])])];
        }),
        _: 1
      })]);
    };
  }
};